import React from 'react';
import { Box, Button, Container, FormControl, Grid, IconButton, Input, InputAdornment, InputBase, InputLabel, Link, List, ListItem, ListItemText, OutlinedInput, Paper, Snackbar, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Service from '../../../../util/Service';

import "../../../../App.css";
import { Home, PlaylistRemove, Rule } from '@mui/icons-material';
import RulesPopover from './RulesPopover';
import EscolhePaginaComp from '../comps/EscolhePaginaComp';

export default function UsuarioForm() {
    const params = useParams();
    const navigate = useNavigate();
    const [user, setUser] = React.useState();
    const [regras, setRegras] = React.useState();
    const [podeSalvar, setPodeSalvar] = React.useState(false);
    const [confirm, setConfirm] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [pagina, setPagina] = React.useState();

    const id = params.id;

    React.useEffect(() => {
        buscaUser();
        buscaRegras();
    }, []);

    React.useEffect(() => {
        if (user) {
            const pg = user.paginaHome;
            if (pg) {
                if (pg.charAt(0) === "/") {
                    setPagina({
                        nome: pg
                    })
                } else if (pg.toUpperCase().indexOf("HTTP") >= 0) {
                    setPagina({
                        nome: pg
                    })
                } else {
                    buscaPagina(pg)
                }
            }

        }
    }, [user])

    React.useEffect(() => {
        if (podeSalvar) {

            let u = {
                id: user.id,
                rules: user.rules
            };
            console.log( u )
            Service.POST("/api/security/user/updateRegra", u).then(r => {
                setPodeSalvar(false);
            }).catch(er => {
                console.log(er)
            });
        }
    }, [podeSalvar])

    function buscaPagina(id) {
        Service.GET("/api/paginaHtml/buscaPorId/" + id).then(r => setPagina(r));
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    function handleRemoveRule(regra) {
        const arr = [];
        for (const r of user.rules) {
            if (r === regra) continue;
            arr.push(r);
        }
        const u = { ...user }
        u.rules = arr;
        setUser(u);
        setPodeSalvar(true);
    }
    function buscaUser() {
        Service.GET("/api/security/user/findById/" + id).then(r => {
            setUser(r);
        })
    }
    function buscaRegras() {
        Service.GET("/api/acesso/findAll").then(r => setRegras(r))
    }

    function getNomeRegra(regra) {
        if (!regras) return '';
        const item = regras.find(r => r.nome === regra)
        if (!item) return '???';
        return item.descricao;
    }

    function handleChange(e) {
        const u = { ...user };
        u[e.target.id] = e.target.value;
        setUser(u);
    }
    function getDadoPapinaHome(){
        if( !pagina) return null;
        if( typeof pagina === 'string')return pagina;
        else return pagina.nome;
    }
    function handleSalvarUser() {
        const dado = {
            id: user.id,
            nome: user.nome,
            login: user.login,
            email: user.email,
            emailCorp: user.emailCorp,
            paginaHome: getDadoPapinaHome(),
            
        }

        Service.POST("/api/security/user/update", dado).then(r => {
            if (r.success) {
                navigate("/gerenciar/users");
            } else {
                //TODO implementar....
                alert("Problema: " + JSON.stringify(r))
            }
        }
        );
    }

    function salvaNovaRule(rule) {
        const u = { ...user };
        if (!u.rules) u.rules = []
        u.rules.push(rule.nome);

        console.log( u.rules );

        setUser(u);

        setPodeSalvar(true);
    }
    function handleEscolhePagina(pg) {
        setPagina(pg);
        console.log( pg );
    }

    if (!user) return (
        <p>Aguarde....</p>
    )
    return (
        <Container sx={{ padding: 2 }} maxWidth="xl">
            <Link underline="none" 
                component="button"
                variant="body2"
                onClick={() => {console.log('....'); navigate('/gerenciar/users')}}
            >
                Usuários 2
            </Link> » {user.nome}
            <Paper sx={{ width: '100%', mb: 2, mt:2 }}>
                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid size={8}>
                        <form id="form-cadUser" >
                            <Stack spacing={2} >
                                <Grid container spacing={2} >
                                    <Grid size={6}>
                                        <TextField
                                            id="nome"
                                            name="nome" value={user.nome} onChange={handleChange}
                                            label="Nome completo"
                                            fullWidth
                                            // size='small'
                                            variant="standard"
                                            required={true}
                                        />
                                    </Grid>
                                    <Grid size={6}>
                                        <EscolhePaginaComp action={handleEscolhePagina} pagina={pagina} />
                                    </Grid>
                                </Grid>
                                <div>
                                    <TextField
                                        id="login"
                                        name="login" value={user.login} onChange={handleChange}
                                        label="Login"
                                        width="50"
                                        size='small'
                                        variant="standard"
                                        required={true}
                                    />
                                    <span>a ser implementado...</span>
                                    {/* <TextField sx={{ marginLeft: 5 }}
                                        id="password"
                                        name="password" value={user.password} onChange={handleChange}
                                        label="Senha"
                                        width="50"
                                        type='password'
                                        size='small'
                                        variant="standard"
                                        required={true}
                                        disabled={true}
                                    />
                                    <TextField sx={{ marginLeft: 5 }}
                                        id="confirPass"
                                        name="confirPass" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                                        label="Confirmar senha"
                                        width="50"
                                        type='password'
                                        size='small'
                                        variant="standard"
                                        disabled={true}
                                    /> */}
                                </div>
                                <TextField
                                    id="email"
                                    name="email" value={user.email} onChange={handleChange}
                                    label="Email"
                                    fullWidth
                                    size='small'
                                    type='email'
                                    required={true}
                                    variant="standard"
                                />
                                {/* <TextField
                                    id="emailCorp"
                                    name="emailCorp" value={user.emailCorp || ''} onChange={handleChange}
                                    label="Email Corporativo"
                                    fullWidth
                                    size='small'
                                    type='email'
                                    required={true}
                                    variant="standard"
                                    helperText="Para receber notificações e atividades coorporativa"
                                /> */}
                            </Stack>
                        </form>
                    </Grid>
                    <Grid size={4}>
                        <Paper sx={{ maxWidth: 360 }} className='posRigth'>
                            <Typography
                                className='posRigth'
                                variant="body"
                                component='div'
                                // alignContent={"center"}
                                // alignSelf={"center"}
                                // alignItems={"center"}
                                // align='center'
                                sx={{ color: 'text.primary' }}
                            >
                                Regras {(user && user.nome) ? user.nome : " do colaborador"}
                                <RulesPopover user={user} regras={regras} ml={5} action={salvaNovaRule} />

                            </Typography>
                            <List
                                sx={{
                                    width: '100%', maxWidth: 340, bgcolor: 'background.paper',
                                    overflow: 'auto',
                                    maxHeight: 420,
                                }}
                            >
                                {user && user.rules && user.rules.map((row, id) =>
                                    <ListItem
                                        alignItems="flex-start" key={"list-" + id}
                                        secondaryAction={
                                            <Tooltip title="Remover">
                                                <IconButton edge="end" aria-label="Remover" onClick={() => handleRemoveRule(row)}>
                                                    <PlaylistRemove />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    >
                                        <ListItemText
                                            primary={row}
                                            secondary={
                                                <React.Fragment>
                                                    <Typography
                                                        component="span"
                                                        variant="body2"
                                                        sx={{ color: 'text.primary', display: 'inline' }}
                                                    >
                                                        {getNomeRegra(row)}
                                                    </Typography>

                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                )}
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <div className='to-right-div'>
                    <Button onClick={handleSalvarUser}>Salvar</Button>
                </div>
            </Paper>

            <Snackbar
                open={open}
                autoHideDuration={5000}
                onClose={handleClose}
                message="Atualizado com sucesso!"
            />
        </Container >

    )
}